<div *ngIf="role === 'admin' || role === 'chain_manager'">
  <nb-card>
    <nb-card-header>
      <div class="header-row">
        <nb-icon icon="monitor-outline"></nb-icon>
        <span>Live POS Tablets</span>
        <span class="tablet-count" *ngIf="tablets.length > 0">{{ tablets.length }}</span>
      </div>
    </nb-card-header>

    <nb-card-body>
      <!-- App View session banner -->
      <div class="active-session-banner" *ngIf="activeSession">
        <div class="banner-left">
          <nb-icon icon="monitor-outline"></nb-icon>
          <span>App View session active</span>
          <span class="connecting-label" *ngIf="!activeSession.stream"> — Connecting...</span>
        </div>
        <button nbButton size="tiny" status="danger" (click)="endSession()">
          <nb-icon icon="close-circle-outline"></nb-icon>
          End Session
        </button>
      </div>

      <!-- Desktop View session banner -->
      <div class="active-session-banner desktop-banner" *ngIf="activeDesktopSession">
        <div class="banner-left">
          <nb-icon icon="grid-outline"></nb-icon>
          <span>Desktop View session active</span>
          <span class="connecting-label" *ngIf="isDesktopConnecting"> — Waiting for frames...</span>
        </div>
        <button nbButton size="tiny" status="danger" (click)="endDesktopSession()">
          <nb-icon icon="close-circle-outline"></nb-icon>
          End Desktop
        </button>
      </div>

      <!-- Empty state -->
      <div *ngIf="tablets.length === 0" class="no-tablets">
        <nb-icon icon="monitor-outline" class="empty-icon"></nb-icon>
        <p>No POS tablets are currently online</p>
        <span class="hint">POS tablets appear here when they connect to the system</span>
      </div>

      <!-- Tablets table -->
      <table class="pos-table" *ngIf="tablets.length > 0">
        <thead>
          <tr>
            <th>Store</th>
            <th>Terminal</th>
            <th>Manager</th>
            <th>Connected Since</th>
            <th>Status</th>
            <th>Desktop Agent</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tablet of tablets">
            <td>{{ tablet.storeName || tablet.storeId }}</td>
            <td>{{ tablet.terminalName || tablet.terminalId }}</td>
            <td>{{ tablet.managerName || tablet.managerId }}</td>
            <td>{{ formatTime(tablet.connectedAt) }}</td>
            <td>
              <span class="status-badge online">Online</span>
              <span
                class="status-badge desktop-agent"
                *ngIf="getAgentForTablet(tablet.terminalId)"
                title="Desktop View agent connected ({{ getAgentForTablet(tablet.terminalId)?.screenWidth }}×{{ getAgentForTablet(tablet.terminalId)?.screenHeight }})">
                Desktop
              </span>
            </td>
            <td class="desktop-agent-cell">
              <ng-container *ngIf="posAgentAdminService.isAgentOnline(tablet.terminalId)">
                <span class="badge badge-success" style="margin-right: 8px;">Online</span>
                <button
                  nbButton
                  size="tiny"
                  status="info"
                  [disabled]="desktopOverlayVisible"
                  (click)="startDesktopView(tablet.terminalId)">
                  Full Desktop
                </button>
              </ng-container>
              <ng-container *ngIf="!posAgentAdminService.isAgentOnline(tablet.terminalId)">
                <span class="badge badge-secondary" style="opacity:0.5">—</span>
              </ng-container>
            </td>
            <td class="actions-cell">
              <!-- App View button -->
              <button
                nbButton
                size="tiny"
                status="primary"
                [disabled]="activeSession !== null || isConnecting || activeDesktopSession !== null"
                (click)="takeControl(tablet.socketId)">
                <nb-icon icon="monitor-outline"></nb-icon>
                {{ isConnecting ? 'Connecting...' : 'App View' }}
              </button>

              <!-- Full Desktop button (CallOverlay) — only visible when a pos-agent is online for this terminal -->
              <button
                nbButton
                size="tiny"
                status="info"
                *ngIf="getAgentForTablet(tablet.terminalId)"
                [disabled]="activeSession !== null || activeDesktopSession !== null || isDesktopConnecting"
                (click)="takeDesktopControl(tablet.terminalId)">
                <nb-icon icon="grid-outline"></nb-icon>
                {{ isDesktopConnecting ? 'Connecting...' : 'Full Desktop' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>

<!-- Desktop Overlay — standalone floating window via PosAgentAdminService -->
<app-desktop-overlay
  *ngIf="desktopOverlayVisible && desktopControlTerminalId"
  [terminalId]="desktopControlTerminalId"
  (closed)="onDesktopOverlayClosed()">
</app-desktop-overlay>

<div *ngIf="role !== 'admin' && role !== 'chain_manager'" class="access-denied">
  <nb-icon icon="lock-outline"></nb-icon>
  <p>Access restricted to admins and chain managers.</p>
</div>
